import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { Save } from "@material-ui/icons";
import moment from "moment-timezone";
import { CheckboxGroupInput, required } from "react-admin";
import { Form } from "react-final-form";
import { MyDateTimeInput } from "../../../MyDateTimeInput";

const defaultScheduleForm = {
  restricted_schedule_start_time: "",
  restricted_schedule_end_time: "",
  restricted_schedule_region: ["HK", "MO"],
  restricted_schedule_type: ["live", "timeshift"],
};

const toInputDateTime = (date, time) => {
  if (!date || !time) return "";
  return moment.tz(`${date} ${time}`, "Asia/Hong_Kong").toDate();
};

const toScheduleForm = (schedule) => {
  if (!schedule) return { ...defaultScheduleForm };

  return {
    restricted_schedule_start_time: toInputDateTime(schedule.start_date, schedule.start_time),
    restricted_schedule_end_time: toInputDateTime(schedule.end_date, schedule.end_time),
    restricted_schedule_region: schedule.region || [],
    restricted_schedule_type: schedule.type || [],
  };
};

const toSchedulePayload = (formData) => {
  const startTime = moment.tz(formData.restricted_schedule_start_time, "Asia/Hong_Kong");
  const endTime = moment.tz(formData.restricted_schedule_end_time, "Asia/Hong_Kong");

  return {
    start_date: startTime.format("YYYY-MM-DD"),
    start_time: startTime.format("HH:mm:ss"),
    end_date: endTime.format("YYYY-MM-DD"),
    end_time: endTime.format("HH:mm:ss"),
    region: formData.restricted_schedule_region,
    type: formData.restricted_schedule_type,
  };
};

const regionChoices = [
  { id: "HK", name: "HK" },
  { id: "MO", name: "MO" },
];

const typeChoices = [
  { id: "live", name: "Live" },
  { id: "timeshift", name: "Timeshift" },
];

export const RestrictedScheduleDialog = ({ open, mode, initialValue, onClose, onSave }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{mode === "edit" ? "Edit" : "Create"}</DialogTitle>
      <Form
        initialValues={toScheduleForm(initialValue)}
        onSubmit={(formData) => {
          onSave(toSchedulePayload(formData));
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={1} fullWidth>
                <Grid item xs={12} sm={12} md={6}>
                  <MyDateTimeInput label="Start Time" source="restricted_schedule_start_time" validate={required()} showSeconds fullWidth />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <MyDateTimeInput label="End Time" source="restricted_schedule_end_time" validate={required()} showSeconds fullWidth />
                </Grid>
              </Grid>
              <Grid container spacing={1} fullWidth>
                <Grid item xs={12} sm={12} md={12}>
                  <CheckboxGroupInput label="Restricted Region" source="restricted_schedule_region" choices={regionChoices} validate={required()} />
                </Grid>
              </Grid>
              <Grid container spacing={1} fullWidth>
                <Grid item xs={12} sm={12} md={12}>
                  <CheckboxGroupInput label="Type" source="restricted_schedule_type" choices={typeChoices} validate={required()} />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: "flex-start" }}>
              <Button onClick={onClose}>Cancel</Button>
              <Button color="primary" variant="contained" startIcon={<Save />} type="submit">
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  );
};
